import { textRecipe } from '@prose-ui/components/text.css';

import { type ReactNode, useEffect } from 'react';

import { Link } from 'react-router';

import { useAppDispatch } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { handleKeyPress } from 'utils/a11y';

import { trackHeapEvent } from 'dux/tracking/actions';

const Wrapper = styled.div`
  z-index: ${theme.zIndex.appBar};

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: ${theme.env.bannerHeight};

  color: var(--wrapper-color, ${theme.colors.neutral[100]});
  text-align: center;

  background-color: var(--wrapper-bg-color, unset);

  transition: background 0.3s ease;

  & em {
    font-style: normal;
    text-decoration: underline;
  }

  &[data-has-bottom-modal] {
    cursor: pointer;
    text-decoration: underline;
  }
`;

let lastEvent: string | undefined;

export const BaseBanner = ({
  children,
  hasLink,
  backgroundColor,
  color,
  buttonProps,
  dataTestId = 'banner',
  event,
}: {
  children?: ReactNode;
  hasLink?: boolean;
  backgroundColor?: string;
  color?: string;
  dataTestId?: string;
  event?: string;
  buttonProps?: {
    onClick?: () => void;
    dataClick?: string;
    dataFrom?: string;
    ariaLabel?: string;
  };
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (lastEvent !== event) {
      dispatch(trackHeapEvent('Banner Displayed - Non-Data Driven', { bannerType: event }));
      lastEvent = event;
    }
  }, [event]);

  return (
    <Wrapper
      aria-label={buttonProps?.ariaLabel}
      className={textRecipe({ variant: 'body5regular' })}
      data-click={buttonProps?.dataClick}
      data-from={buttonProps?.dataFrom}
      data-has-bottom-modal={buttonProps ? '' : undefined}
      data-has-link={hasLink ? '' : undefined}
      data-testid={dataTestId}
      onClick={buttonProps?.onClick}
      onKeyPress={buttonProps ? handleKeyPress(buttonProps.onClick) : undefined}
      role={buttonProps ? 'button' : undefined}
      style={{
        '--wrapper-bg-color': backgroundColor,
        '--wrapper-color': color,
      }}
      tabIndex={buttonProps ? 0 : -1}
    >
      {children}
    </Wrapper>
  );
};

export const StyledLinkedCTA = styled(Link)`
  color: var(--styled-linked-cta-color, ${theme.colors.neutral[100]});
`;

export const LongLinkCta = styled(Link)`
  display: flex;
  flex-direction: column;
  color: ${theme.colors.neutral[100]};

  @media (min-width: 23.5em) {
    /* INFO: ^ legacy value outside of the current DS tokens */
    display: block;
  }
`;
